import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46877d62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form_input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "newPassword" }, "Email Address", -1))
const _hoisted_3 = { class: "form_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "reEnterPass" }, "Password", -1))
const _hoisted_5 = {
  key: 0,
  class: "error_msg"
}
const _hoisted_6 = { class: "card-info" }
const _hoisted_7 = { class: "card-part" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "common-title" }, "Forgot Password?", -1))
const _hoisted_9 = { class: "card-part" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "common-title" }, "Dont’ have an account?", -1))
const _hoisted_11 = { class: "benefit_wrapper llg:!tw-mb-[20px]" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Take a look at all the amazing benefits iknowa offers", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_AuthIknowaInfoMobileModal = _resolveComponent("AuthIknowaInfoMobileModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_form, {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
      rules: $setup.validation,
      ref: "ruleFormRef",
      class: "md:!tw-pt-[25px]"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_v_text_field, {
            "bg-color": "rgba(12, 15, 74, 0.0509803922)",
            class: "input_field c-input",
            rules: $setup.validation.email,
            rounded: "",
            outlined: "false",
            modelValue: $setup.loginForm.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.loginForm.email) = $event)),
            placeholder: "Email Address",
            variant: "solo"
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_v_text_field, {
            "bg-color": "rgba(12, 15, 74, 0.0509803922)",
            variant: "solo",
            class: _normalizeClass(["input_field password__input", { demo: $setup.validation.password }]),
            rules: $setup.validation.password,
            modelValue: $setup.loginForm.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.loginForm.password) = $event)),
            "append-inner-icon": $setup.isShowPassword ? 'mdi-eye' : 'mdi-eye-off',
            "onClick:appendInner": _cache[2] || (_cache[2] = () => ($setup.isShowPassword = !$setup.isShowPassword)),
            type: $setup.isShowPassword ? 'text' : 'password',
            rounded: "",
            outlined: "false",
            placeholder: "Enter password"
          }, null, 8, ["class", "rules", "modelValue", "append-inner-icon", "type"])
        ]),
        ($setup.loginErrorMessage)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.loginErrorMessage), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_v_checkbox, {
          label: "Remember Me",
          class: "form_input",
          modelValue: $setup.rememberUser,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.rememberUser) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_btn, {
          class: _normalizeClass(["button disabled", { 'button-orange': $setup.isDisabledNextButton }]),
          type: "submit",
          block: "",
          size: "large",
          disabled: !$setup.isDisabledNextButton,
          loading: $setup.loading,
          onClick: $setup.onNextButtonClick
        }, {
          default: _withCtx(() => [
            _createTextVNode("Next ")
          ]),
          _: 1
        }, 8, ["class", "disabled", "loading", "onClick"])
      ]),
      _: 1
    }, 8, ["rules"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("label", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.onClickResetPassword && $setup.onClickResetPassword(...args))),
          class: "yellow-text"
        }, [
          _createTextVNode(" Reset Your Password"),
          _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("label", {
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.onClickRegisterButton && $setup.onClickRegisterButton(...args))),
          class: "yellow-text"
        }, [
          _createTextVNode(" Register"),
          _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h6", null, [
          _createVNode(_component_v_icon, { icon: "mdi-star" }),
          _createTextVNode("iknowa Benefits")
        ])
      ]),
      _hoisted_13,
      _createElementVNode("label", {
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.openOverview && $setup.openOverview(...args))),
        class: "yellow-text"
      }, [
        _createTextVNode("Open iknowa Overview "),
        _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
      ])
    ]),
    ($setup.isShowAuthIknowaInfoMobile)
      ? (_openBlock(), _createBlock(_component_AuthIknowaInfoMobileModal, {
          key: 0,
          onOnCloseButtonClick: $setup.onCloseButtonClick
        }, null, 8, ["onOnCloseButtonClick"]))
      : _createCommentVNode("", true)
  ], 64))
}